module.exports = __webpack_public_path__ + "static/media/KP.5876b2fa.png";